import { FilterType } from '../../enums';

export const FilterMoreEventType = {
  Change: 'change',
};

export const FilterMoreDefaultFilters = [
  FilterType.ListingType,
  FilterType.ListingStatus,
  FilterType.FinishedArea,
  FilterType.LandSize,
  FilterType.YearBuilt,
];
